import { WithTranslation } from 'react-i18next'
import { FormErrors } from 'redux-form'
import i18n from '../../../i18n'
import { IFormValues } from './index'
import { isEmpty } from 'lodash'
import { Mixpanel } from '../../../utils/Mixpanel'

export default function(
  {
    name,
    roomSize,
    singleBed,
    doubleBed,
    additionalBeds,
    ...rest
  }: IFormValues & WithTranslation,
  props,
): FormErrors<IFormValues, string> {
  const errors: FormErrors<IFormValues, string> = {}

  if (name === undefined || name === '' || name.trim() === '') {
    errors.name = i18n.t('name_must_not_empty')
  }
  if (roomSize === undefined || roomSize < 1 || roomSize > 16) {
    errors.roomSize = 'Dopuszczalny rozmiar pokoju to od 1 do 16 osób'
  }
  if (
    additionalBeds === undefined ||
    additionalBeds < 0 ||
    additionalBeds > 4
  ) {
    errors.additionalBeds = 'Dopuszczalna ilość dostawek to od 0 do 4 osób'
  }
  if (singleBed === undefined || singleBed < 0 || singleBed > 16) {
    errors.singleBed = 'Dopuszczalna ilość pojedynczych lóżek to od 0 do 16'
  }
  if (doubleBed === undefined || doubleBed < 0 || doubleBed > 8) {
    errors.doubleBed = 'Dopuszczalna ilość podwójnych lóżek to od 0 do 8'
  }

  if (!isEmpty(errors) && props.anyTouched) {
    Mixpanel.track('Room Form Validation', {
      'Room ID': rest.id || undefined,
    })
  }

  return errors
}
